import React from 'react';
import styled from '@emotion/native';
import { GalleryImages } from '@/shared/types/stylist';
import { IsDesktopProps } from '@/shared/styles/types';
import { GALLERY_CONSTANTS } from '@/shared/styles/constants';
import GalleryButton from './GalleryImage';

interface GalleryLayoutProps {
  galleryImages: GalleryImages;
  onSelectLandscapeImage: () => void;
  onSelectPortraitImage: (index: number) => void;
  onAddPortraitImage: () => void;
  isDesktop: boolean;
  backgroundColor?: string;
}

const GalleryLayout: React.FC<GalleryLayoutProps> = ({
  galleryImages,
  onSelectLandscapeImage,
  onSelectPortraitImage,
  onAddPortraitImage,
  isDesktop,
  backgroundColor,
}) => {
  return (
    <GalleryGrid isDesktop={isDesktop}>
      <GalleryButton
        imageType="landscape"
        key="landscape"
        imageUri={galleryImages.landscapeImage || undefined}
        onPress={onSelectLandscapeImage}
        flexBasis={GALLERY_CONSTANTS.LANDSCAPE_FLEX_BASIS}
        backgroundColor={backgroundColor}
      />

      {[...Array(GALLERY_CONSTANTS.MAX_PORTRAIT_IMAGES)].map((_, index) => (
        <GalleryButton
          imageType="portrait"
          key={`portrait-${index}`}
          imageUri={galleryImages.portraitImages[index]}
          onPress={() =>
            galleryImages.portraitImages[index]
              ? onSelectPortraitImage(index)
              : onAddPortraitImage()
          }
          flexBasis={GALLERY_CONSTANTS.PORTRAIT_FLEX_BASIS}
          backgroundColor={backgroundColor}
        />
      ))}
    </GalleryGrid>
  );
};

export default GalleryLayout;

const GalleryGrid = styled.View<IsDesktopProps>(({ isDesktop }) => ({
  flexDirection: 'row',
  flexWrap: 'wrap',
  columnGap: GALLERY_CONSTANTS.COLUMN_GAP,
  rowGap: GALLERY_CONSTANTS.ROW_GAP,
  alignItems: 'center',
  maxWidth: GALLERY_CONSTANTS.MAX_WIDTH,
  alignSelf: isDesktop ? 'auto' : 'center',
  marginTop: 10,
}));
